import axios from "axios";
import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import ExportToExcel from "../../SExport/ExportToExcle";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
// import { TableSumCustom } from "../../ShortFunction/TableSumCustom";
import { generateCriteriaString } from "./../../ShortFunction/shortFunctions";
import { baseurl } from "../../../../baseurl";
import "../../../../stickyHeaderReport.css";
import { check_Bussiness_Permission } from "../../../../Helper";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import Decimal from "../../ShortCutComponents/Decimal";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./formsTable.css";
import "./baseForms.css";
// import "../../../../index.css";
import swal from "sweetalert";

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
let companyName = localStorage.getItem("companyName");

export default function SaleSummary(props) {
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
    criteriaString: "All",
    collapseCriteria: false,
    time: "",
  });
  const [permission, setPermission] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showAsInteger, setShowAsInteger] = useState(false);
  const [isEmarat, setIsEmarat] = useState(false);
  /**
   * Eggspectation reprints the POS receipt from this report: the Doc No becomes a
   * link that opens /dailySaleReceiptPrint for that invoice. Every other client
   * keeps a plain, unclickable Doc No.
   */
  const [isEggSpectation, setIsEggSpectation] = useState(false);
  /**
   * emarat_r_db calls the surcharge a delivery fee, so the column is relabelled for
   * that client everywhere it is shown - the grid, the Excel export and the print
   * view. The underlying key stays sale_surch so nothing downstream has to change.
   */
  const surchargeLabel = isEmarat ? "Delivery Fee" : "Surcharge";
  const due_Formators = (cell, row, enumObject, index) => {
    let newCell = "";
    newCell = cell;
    if (typeof cell === "string") {
      newCell = parseFloat(cell.replace(/,/g, ""));
    }
    if (newCell) {
      newCell = newCell?.toLocaleString("en-US", {
        maximumFractionDigits: showAsInteger ? 0 : 2,
        minimumFractionDigits: showAsInteger ? 0 : 2,
      });

      // newCell = companySymbolCurrency + " " + newCell;
    } else {
      newCell = "0";
    }
    return newCell;
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const colourOptions = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];
  const listOfColLables = [
    { align: "center", value: "Date" },
    { align: "center", value: "Branch" },
    { align: "center", value: "Doc No" },
    { align: "center", value: "Type" },
    { align: "center", value: "Order ID" },
    { align: "center", value: "Waiter/Rider" },//its not thier
    { align: "center", value: "Paymode" },
    { align: "center", value: "Total" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Tax" },
    { align: "center", value: "Sub-Total" },
    { align: "center", value: surchargeLabel },
    { align: "center", value: "Net-Total" },
    { align: "center", value: "Channel" },
  ];
  const listOfColLablesDollar = [
    { align: "center", value: "Sr No." },
    { align: "center", value: "Date" },
    { align: "center", value: "Branch" },
    { align: "center", value: "Doc No" },
    { align: "center", value: "Gross" },
    { align: "center", value: "Discount" },
    { align: "center", value: "Sub-Total" },
    { align: "center", value: "Tax" },
    { align: "center", value: "Net-Total" },
    { align: "center", value: "time" },
  ];

  const listOfColKey = [
    { align: "left", value: "INVOICE_DATE" },
    { align: "left", value: "sub_inv_desc" },
    { align: "left", value: "DOCUMENT_NO" },
    { align: "left", value: "order_type_desc" },
    { align: "left", value: "chan_pos_id" },
    { align: "left", value: "waitor_desc" },
    { align: "left", value: "paymode_desc" },
    { align: "right", value: "total" },
    { align: "center", value: "discount" },
    { align: "center", value: "stax_amount" },
    { align: "center", value: "sub_total" },
    { align: "center", value: "sale_surch" },
    { align: "center", value: "net_total" },
    { align: "center", value: "channel_desc" },
  ];
  const listOfColKeyDollar = [
    { align: "center", value: "sr_no" },
    { align: "left", value: "INVOICE_DATE" },
    { align: "left", value: "sub_inv_desc" },
    { align: "left", value: "DOCUMENT_NO" },
    { align: "center", value: "total" },
    { align: "center", value: "discount" },
    { align: "center", value: "sub_total" },
    { align: "center", value: "stax_amount" },
    { align: "center", value: "net_total" },
    { align: "center", value: "time" },
  ];
  const [table, setTable] = useState({
    OverViewDataTable: [],
    filteredData: [],
  });
  const [filteredData, setFilteredData] = useState([]);
  const [dollarTrue, setdollarTrue] = useState(false);
  const [Item, setItem] = useState({
    itemLov: "",
    item_id: "",
    itemName: "",
  });

  useEffect(() => {
    checkBussinessPermission();

    // getAccountsSummary();
  }, []);

  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission[0]);
    let {
      business_type_id,
      isCrumble,
      isAgh,
      isDollarjnction,
      isEmarat,
      isEggSpectation,
    } = checkBussinessPermission;
    if (isDollarjnction) {
      setdollarTrue(true);
      setShowAsInteger(true);
    }
    if (isEmarat) {
      setIsEmarat(true);
    }
    if (isEggSpectation) {
      setIsEggSpectation(true);
    }
  };

  /**
   * Opens the POS receipt for one invoice in a new tab. The invoice id travels
   * through localStorage rather than router state because the receipt is a
   * separate window - same handover the report's own print already uses.
   */
  const openReceiptPrint = (invoiceId) => {
    if (!invoiceId) return;
    localStorage.setItem(
      "dailySaleReceiptPrintState",
      JSON.stringify({ invoiceId })
    );
    window.open("#/dailySaleReceiptPrint", "_blank");
  };

  const funPrintView = (data1, headers, headerKeyMap, allData) => {
    let fromDate = allData.fromDate
      ? moment(allData.fromDate).format("DD-MMM-YYYY")
      : "All";
    let toDate = allData.toDate
      ? moment(allData.toDate).format("DD-MMM-YYYY")
      : "All";

    let dateCriteria =
      fromDate === "All" && toDate === "All"
        ? {
            label: "Date",
            value: "All",
          }
        : ({
            label: "From Date",
            value: fromDate,
          },
          {
            label: "To Date",
            value: toDate,
          });
    let criteria = [
      // dateCriteria,
      // {
      //   label: "Customer",
      //   value: customer_id?.label ? customer_id?.label : "All",
      // },
      // {
      //   label: "Item",
      //   value: item_id?.label ? item_id?.label : "All",
      // },
      // {
      //   label: "Status",
      //   value: radioOption,
      // },
      // {
      //   label: "Invoice Type",
      //   value: radioOption2,
      // },
    ];
    const formattedPrintData = dollarTrue
      ? table.printDataDollar.map((item) => ({
          sr_no: item.sr_no,
          INVOICE_DATE: item.INVOICE_DATE,
          sub_inv_desc: item.sub_inv_desc,
          DOCUMENT_NO: item.DOCUMENT_NO,
          total: due_Formators(item.total),
          discount: due_Formators(item.discount),
          sub_total: due_Formators(item.sub_total),
          stax_amount: due_Formators(item.stax_amount),
          net_total: due_Formators(item.net_total),
          time: item.time,
        }))
      : table.printData.map((item) => ({
          INVOICE_DATE: item.INVOICE_DATE,
          sub_inv_desc: item.sub_inv_desc,
          DOCUMENT_NO: item.DOCUMENT_NO,
          order_type_desc: item.order_type_desc,
          chan_pos_id: item.chan_pos_id,
          waitor_desc: item.waitor_desc,
          paymode_desc: item.paymode_desc,
          total: due_Formators(item.total),
          discount: due_Formators(item.discount),
          stax_amount: due_Formators(item.stax_amount),
          sub_total: due_Formators(item.sub_total),
          sale_surch: due_Formators(item.sale_surch),
          net_total: due_Formators(item.net_total),
          channel_desc: item.channel_desc,
          time: item.time,
        }));

    // props.history.push({
    //   pathname: "/PrintReports",
    //   state: {
    //     data: formattedPrintData,
    //     headers: headers,
    //     headerKeyMap: headerKeyMap,
    //     goBackUrl: "/dailySale_Receipt",
    //     dynamicInvMessage: "Daily Sale/Receipt Report",
    //     reportName: "Daily_Sale/Receipt_Report",
    //     criteria,
    //     criteriaString: data.criteriaString,
    //   },
    // });
    const reportState = {
      data: formattedPrintData,
      headers: headers,
      headerKeyMap: headerKeyMap,
      goBackUrl: "/dailySale_Receipt",
      dynamicInvMessage: "Daily Sale/Receipt Report",
      reportName: "Daily_Sale/Receipt_Report",
      criteria,
      criteriaString: data.criteriaString,
    };
    localStorage.setItem("reportState", JSON.stringify(reportState));
    window.open("#/PrintReportsNew", "_blank");
  };
  const graph = () => {
    swal({
      title: "Coming Soon",
      text: "This feature is under development",
      icon: "warning",
      timer: 2000,
      buttons: false,
    });
  };

  const getAccountsSummary = (
    startDate,
    endDate,
    orderType_id,
    payMode_id,
    multiPosBranch,
    branch_id,
    saleChannel_id,
    radioBtn3,
    fromTime,
    toTime
  ) => {
    setIsLoading(true);

    let sDate = startDate ? moment(startDate).format("YYYY-MM-DD") : null;
    let eDate = endDate ? moment(endDate).format("YYYY-MM-DD") : null;
    let stTime = fromTime ? moment(fromTime).format("hh:mm A") : null;
    let edTime = toTime ? moment(toTime).format("hh:mm A") : null;

    console.log("multiPosBranch :>> ", multiPosBranch);
    console.log("branch_id :>> ", branch_id);
    // let sysDate = new Date();
    // return;
    axios
      .post(
        `${baseurl}/repots/getDailySale_ReceiptReport`,
        {
          companyId,
          fromDate: sDate,
          toDate: eDate,
          discountType: radioBtn3,
          orderType: orderType_id?.id, // orderType_id?.multiOrderType,
          payMode: payMode_id?.id, //payMode_id?.multiPayMode,
          saleChannel_id: saleChannel_id?.id, //payMode_id?.multiPayMode,
          username,
          multiPosBranch: multiPosBranch || branch_id?.id || branch_id, //multiPosBranch?.id || branch_id?.id,
          stTime,
          edTime,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        let callData = response.data.data;

        let totalSumAll = {
          total: 0,
          discount: 0,
          stax_amount: 0,
          sub_total: 0,
          sale_surch: 0,
          net_total: 0,
        };
        let objEmpty = {
          INVOICE_DATE: "",
          sub_inv_desc: "",
          DOCUMENT_NO: "",
          order_type_desc: "",
          chan_pos_id: "",
          waitor_desc: "",
          total: "",
          discount: "",
          stax_amount: "",
          sub_total: "",
          sale_surch: "",
          net_total: "",
          channel_desc: "",
        };
        let objEmptyDollar = {
          sr_no: "",
          INVOICE_DATE: "",
          sub_inv_desc: "",
          DOCUMENT_NO: "",
          total: "",
          discount: "",
          sub_total: "",
          stax_amount: "",
          net_total: "",
          time: "",
        };
        let newArr = [
          {
            INVOICE_DATE: "Daily Sale/Receipt Report",
            sub_inv_desc: "",
            DOCUMENT_NO: "",
            order_type_desc: "",
            chan_pos_id: "",
            waitor_desc: "",
            paymode_desc: "",
            total: "",
            discount: "",
            stax_amount: "",
            sub_total: "",
            sale_surch: "",
            net_total: `*Note : All figures indicated are in the company currency (  ${companySymbolCurrency} )`,
            channel_desc: "",
          },
          objEmpty,
          {
            INVOICE_DATE: "Date",
            sub_inv_desc: "Branch",
            DOCUMENT_NO: "No",
            order_type_desc: "Type",
            chan_pos_id: "Order ID",
            waitor_desc: "waitor_desc",
            paymode_desc: "Paymode",
            total: "Total",
            discount: "Dicount",
            stax_amount: "Sale Tax",
            sub_total: "Sub Total",
            sale_surch: surchargeLabel,
            net_total: "Net Total",
            channel_desc: "Type",
          },
        ];
        let newArrDollar = [
          {
            sr_no: "Daily Sale/Receipt Report",
            INVOICE_DATE: "",
            sub_inv_desc: "",
            DOCUMENT_NO: "",
            total: "",
            discount: "",
            sub_total: "",
            stax_amount: "",
            net_total: "",
            time: `*Note : All figures indicated are in the company currency (  ${companySymbolCurrency} )`,
          },
          objEmptyDollar,
          {
            sr_no: "sr_no",
            INVOICE_DATE: "Date",
            sub_inv_desc: "Branch",
            DOCUMENT_NO: "No",
            total: "Gross",
            discount: "Dicount",
            sub_total: "Sub Total",
            stax_amount: "Sale Tax",
            net_total: "Net Total",
            time: "time",
          },
        ];
        let sumTotal = 0;
        let sumDiscount = 0;
        let sumSaleTaAmt = 0;
        let sumSubTotal = 0;
        let sumSurcharge = 0;
        let sumNetTotal = 0;
        let printData = [];
        let printDataDollar = [];
        for (let index = 0; index < callData.length; index++) {
          let element = callData[index];

          sumTotal = sumTotal + Number(element?.total);
          sumDiscount = sumDiscount + Number(element?.discount);
          sumSaleTaAmt = sumSaleTaAmt + Number(element?.stax_amount);
          sumSubTotal = sumSubTotal + Number(element?.sub_total);
          sumSurcharge = sumSurcharge + Number(element?.sale_surch);
          sumNetTotal = sumNetTotal + Number(element?.net_total);

          totalSumAll = {
            sumTotal: totalSumAll.total + Number(element?.total),
            sumDiscount: totalSumAll.discount + Number(element?.discount),
            sumSaleTaAmt:
              totalSumAll.stax_amount + Number(element?.stax_amount),
            sumSubTotal: totalSumAll.sub_total + Number(element?.sub_total),
            sumSurcharge: totalSumAll.sale_surch + Number(element?.sale_surch),
            sumNetTotal: totalSumAll.net_total + Number(element?.net_total),
          };

          newArr.push({
            INVOICE_DATE: element["INVOICE_DATE"],
            // DOCUMENT_NO: element["DOCUMENT_NO"],
            sub_inv_desc: element["sub_inv_desc"],
            DOCUMENT_NO: element["formated_doc_no"],
            order_type_desc: element["order_type_desc"],
            chan_pos_id: element["chan_pos_id"],
            waitor_desc: element["waitor_desc"],
            paymode_desc: element["paymode_desc"],
            total: element["total"],
            discount: element["discount"],
            stax_amount: element["stax_amount"],
            sub_total: element["sub_total"],
            sale_surch: element["sale_surch"],
            net_total: element["net_total"],
            channel_desc: element["channel_desc"],
            time: element["time"],
          });

          newArrDollar.push({
            sr_no: index + 1,
            INVOICE_DATE: element["INVOICE_DATE"],
            // DOCUMENT_NO: element["DOCUMENT_NO"],
            sub_inv_desc: element["sub_inv_desc"],
            DOCUMENT_NO: element["formated_doc_no"],
            total: due_Formators(Number(element["total"])),
            discount: due_Formators(Number(element["discount"])),
            sub_total: due_Formators(Number(element["sub_total"])),
            stax_amount: due_Formators(Number(element["stax_amount"])),
            net_total: due_Formators(Number(element["net_total"])),
            time: element["time"],
          });

          printData.push({
            // carried for the Doc No receipt link only - funPrintView cherry-picks
            // the keys it prints, so this never reaches the report print itself
            INVOICE_ID: element["INVOICE_ID"],
            INVOICE_DATE: moment(element["INVOICE_DATE"]).format("D-MMM-YYYY"),
            // DOCUMENT_NO: element["DOCUMENT_NO"],
            sub_inv_desc: element["sub_inv_desc"],
            DOCUMENT_NO: element["formated_doc_no"],
            order_type_desc: element["order_type_desc"],
            chan_pos_id: element["chan_pos_id"],
            waitor_desc: element["waitor_desc"],
            paymode_desc: element["paymode_desc"],
            total: due_Formators(element["total"]),
            discount: due_Formators(element["discount"]),
            stax_amount: due_Formators(element["stax_amount"]),
            sub_total: due_Formators(element["sub_total"]),
            sale_surch: due_Formators(element["sale_surch"]),
            net_total: due_Formators(element["net_total"]),
            channel_desc: element["channel_desc"],
            time: element["time"],
          });
          printDataDollar.push({
            sr_no: index + 1,
            INVOICE_DATE: moment(element["INVOICE_DATE"]).format("D-MMM-YYYY"),
            // DOCUMENT_NO: element["DOCUMENT_NO"],
            sub_inv_desc: element["sub_inv_desc"],
            DOCUMENT_NO: element["formated_doc_no"],
            total: due_Formators(element["total"]),
            discount: due_Formators(element["discount"]),
            sub_total: due_Formators(element["sub_total"]),
            stax_amount: due_Formators(element["stax_amount"]),
            net_total: due_Formators(element["net_total"]),
            time: element["time"],
          });
        }

        newArr.push(objEmpty);
        newArr.push({
          INVOICE_DATE: "Total",
          sub_inv_desc: "",
          DOCUMENT_NO: "0",
          order_type_desc: "0",
          chan_pos_id: "0",
          waitor_desc: "0",
          paymode_desc: "0",
          total: sumTotal,
          discount: sumDiscount,
          stax_amount: sumSaleTaAmt,
          sub_total: sumSubTotal,
          sale_surch: sumSurcharge,
          net_total: sumNetTotal,
          channel_desc: "0",
        });
        newArrDollar.push(objEmptyDollar);
        newArrDollar.push({
          sr_no: "Total",
          INVOICE_DATE: "",
          sub_inv_desc: "",
          DOCUMENT_NO: "0",
          total: sumTotal,
          discount: sumDiscount,
          sub_total: sumSubTotal,
          stax_amount: sumSaleTaAmt,
          net_total: sumNetTotal,
          time: "",
        });

        let mainScreenDataTable = [...printData];
        printData.push({
          INVOICE_DATE: "Total",
          sub_inv_desc: "-",
          DOCUMENT_NO: "-",
          order_type_desc: "-",
          chan_pos_id: "-",
          waitor_desc: "-",
          paymode_desc: "-",
          total: due_Formators(Number(sumTotal)),
          discount: due_Formators(Number(sumDiscount)),
          stax_amount: due_Formators(Number(sumSaleTaAmt)),
          sub_total: due_Formators(Number(sumSubTotal)),
          sale_surch: due_Formators(Number(sumSurcharge)),
          net_total: due_Formators(Number(sumNetTotal)),
          channel_desc: "-",
        });
        printDataDollar.push({
          sr_no: "Total",
          INVOICE_DATE: "",
          sub_inv_desc: "",
          DOCUMENT_NO: "0",
          total: due_Formators(Number(sumTotal)),
          discount: due_Formators(Number(sumDiscount)),
          sub_total: due_Formators(Number(sumSaleTaAmt)),
          stax_amount: due_Formators(Number(sumSubTotal)),
          net_total: due_Formators(Number(sumNetTotal)),
          time: "-",
        });
        console.log("sumTotal=", due_Formators(sumTotal));
        console.log("printData=", printData);
        setTable({
          ...table,
          OverViewDataTable: mainScreenDataTable,
          printData,
          printDataDollar,
          totalSumAll,
          listOfData: newArr,
          listOfDataDollar: newArrDollar,
        });
        setIsLoading(false);

        setFilteredData(JSON.parse(JSON.stringify(mainScreenDataTable)));
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
      });
  };
  const defaultValueLov = {
    id: "-1",
    label: "All",
  };
  const handleFind = (p) => {
    console.log("p", p);
    const {
      fromDate,
      toDate,
      orderType_id,
      payMode_id,
      multiOrderTypeLabel,
      multiPayModeLabel,
      multiPosBranchLabel,
      multiPosBranch,
      branch_id,
      radioBtn3,
      saleChannel_id,
      multiSaleChannelLabel,
      fromTime,
      toTime,
    } = p;

    const critObj = {
      fromDate,
      toDate,
      orderType_id,
      payMode_id,
      radioBtn3,
      multiOrderTypeLabel: multiOrderTypeLabel || orderType_id?.label,
      multiPayModeLabel: multiPayModeLabel || payMode_id?.label,
      multiPosBranchLabel: multiPosBranchLabel || branch_id?.label,
      multiPosBranch: multiPosBranch || branch_id,
      branch_id,
      multiSaleChannelLabel: multiSaleChannelLabel || saleChannel_id?.label,
      fromTime,
      toTime,
      timeTure: true,
    };
    const criteriaString = generateCriteriaString(critObj);
    setData({
      criteriaString: criteriaString,
    });
    console.log("criteriaString :>> ", criteriaString);
    let BranchCheck = multiPosBranch || branch_id;
    if (!BranchCheck) {
      swal({
        title: "Branch Not Selected",
        text: "Please select branch",
        icon: "warning",
      });
      return;
    }
    getAccountsSummary(
      fromDate,
      toDate,
      orderType_id,
      payMode_id,
      multiPosBranch,
      branch_id,
      saleChannel_id,
      radioBtn3,
      fromTime,
      toTime
    );
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to last",
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "All", value: filteredData?.length || 100 }, // fallback
    ],
    custom: true,
  };
  const totalSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.total.replace(/,/g, "")),
    0
  );
  const discountSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.discount.replace(/,/g, "")),
    0
  );
  const taxSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.stax_amount.replace(/,/g, "")),
    0
  );
  const subTotalSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.sub_total.replace(/,/g, "")),
    0
  );
  const surchargeSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.sale_surch.replace(/,/g, "")),
    0
  );
  const netTotalSum = filteredData.reduce(
    (acc, item) => acc + parseFloat(item.net_total.replace(/,/g, "")),
    0
  );

  /**
   * "No" holds the formatted document number - a bare number, or one tagged with the
   * sale channel ("FP-1024", "BL-77", "BLM-9"). Sorted as text that puts 100 before 99,
   * so compare the numeric part as a number instead. Document numbers with no digits at
   * all keep a text comparison and are pushed to the end.
   */
  const docNoSortFunc = (a, b, order) => {
    const asText = (v) => (v === null || v === undefined ? "" : String(v));
    const numOf = (v) => {
      const match = asText(v).match(/(\d+)(?!.*\d)/);
      return match ? Number(match[1]) : null;
    };
    const numA = numOf(a);
    const numB = numOf(b);
    let result;
    if (numA === null && numB === null) {
      result = asText(a).localeCompare(asText(b));
    } else if (numA === null) {
      result = 1;
    } else if (numB === null) {
      result = -1;
    } else {
      result = numA - numB;
      if (result === 0) {
        result = asText(a).localeCompare(asText(b));
      }
    }
    return order === "desc" ? -result : result;
  };

  const columns = [
    {
      dataField: "INVOICE_DATE",
      text: "Date",
      sort: true,
      footer: "Total",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "sub_inv_desc",
      text: "Branch",
      sort: true,
      style: { textAlign: "Center" },
      footer: "-",
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "DOCUMENT_NO",
      text: "No",
      sort: true,
      sortFunc: docNoSortFunc,
      style: { textAlign: "Center" },
      footer: "-",
      footerStyle: { textAlign: "Center" },
      /**
       * Eggspectation only: the Doc No opens that invoice's POS receipt in a new
       * tab. Rows carrying no INVOICE_ID stay plain text, and so does every
       * other client.
       */
      formatter: (cell, row) => {
        if (!isEggSpectation || !row || !row.INVOICE_ID) return cell;
        return (
          <a
            href="#"
            title="Print POS receipt"
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              openReceiptPrint(row.INVOICE_ID);
            }}
          >
            {cell}
          </a>
        );
      },
    },
    {
      dataField: "order_type_desc",
      text: "Type",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "chan_pos_id",
      text: "Order ID",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "waitor_desc",
      text: "Waiter/Rider",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "paymode_desc",
      text: "Paymode",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "total",
      text: "Total",
      sort: true,
      formatter: due_Formators,
      footer: () => (totalSum ? due_Formators(totalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "discount",
      text: "Discount",
      sort: true,
      formatter: due_Formators,
      footer: () => (discountSum ? due_Formators(discountSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "stax_amount",
      text: "Tax",
      sort: true,
      formatter: due_Formators,
      footer: () => (taxSum ? due_Formators(taxSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "sub_total",
      text: "Sub-Total",
      sort: true,
      formatter: due_Formators,
      footer: () => (subTotalSum ? due_Formators(subTotalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "sale_surch",
      text: surchargeLabel,
      sort: true,
      formatter: due_Formators,
      footer: () => (surchargeSum ? due_Formators(surchargeSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "net_total",
      text: "Net-Total",
      sort: true,
      formatter: due_Formators,

      footer: () => (netTotalSum ? due_Formators(netTotalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "channel_desc",
      text: "Channel",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
  ];
  const Dollar_columns = [
    {
      dataField: "INVOICE_DATE",
      text: "Date",
      sort: true,
      footer: "-",
      style: { textAlign: "Center" },
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "sub_inv_desc",
      text: "Branch",
      sort: true,
      style: { textAlign: "Center" },
      footer: "-",
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "DOCUMENT_NO",
      text: "No",
      sort: true,
      sortFunc: docNoSortFunc,
      style: { textAlign: "Center" },
      footer: "-",
      footerStyle: { textAlign: "Center" },
    },
    {
      dataField: "total",
      text: "Gross",
      sort: true,
      formatter: due_Formators,

      footer: () => (totalSum ? due_Formators(totalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "discount",
      text: "Discount",
      sort: true,
      formatter: due_Formators,

      footer: () => (discountSum ? due_Formators(discountSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "sub_total",
      text: "Sub-Total",
      sort: true,
      formatter: due_Formators,

      footer: () => (subTotalSum ? due_Formators(subTotalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "stax_amount",
      text: "Tax",
      sort: true,
      formatter: due_Formators,

      footer: () => (taxSum ? due_Formators(taxSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "net_total",
      text: "Net-Total",
      sort: true,
      formatter: due_Formators,

      footer: () => (netTotalSum ? due_Formators(netTotalSum) : 0),
      style: { textAlign: "right" },
      footerStyle: { textAlign: "right" },
    },
    {
      dataField: "time",
      text: "In Time",
      style: { textAlign: "Center" },
      footer: "-",
      footerStyle: { textAlign: "Center" },
    },
  ];

  const defaultSorted = [
    {
      dataField: "name",
      order: "desc",
    },
  ];
  const handleDynamicColapse = (p) => {
    console.log("p", p);
    const { collapseCriteria } = p;
    setData({
      ...data,
      collapseCriteria,
    });
  };
  const sendSearchedData = (p) => {
    console.log("p", p);
    const { filteredData } = p;
    setFilteredData(filteredData);
  };
  return (
    <>
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Daily Sale/Receipt Report"
            lovs={[
              "ordertype",
              "paymode",
              "branch",
              "saleChannel",
              "fromTime",
              "toTime",
            ]}
            companyId={companyId}
            token={token}
            username={username}
            status={6}
            // callBack={() => {}}
            handleFind={(p) => handleFind(p)}
            tableData={table.OverViewDataTable}
            callBack={(p) => handleDynamicColapse(p)}
            sendSearchedData={(p) => sendSearchedData(p)}
            isMulti={false}
          />
          <div className="row float-right pr-4">
            <Button
              color="secondary"
              className="button-22"
              onClick={() => graph()}
              id="invoiceButton"
            >
              Graph
            </Button>
            <Decimal
              showAsInteger={showAsInteger}
              onToggle={setShowAsInteger}
            />
            <Button
              color="success"
              className="button-22 "
              onClick={() => {
                dollarTrue
                  ? funPrintView(
                      table.printDataDollar,
                      listOfColLablesDollar,
                      listOfColKeyDollar,
                      data
                    )
                  : funPrintView(
                      table.printData,
                      listOfColLables,
                      listOfColKey,
                      data
                    );
              }}
              // funPrintView(
              //   table.printData,
              //   listOfColLables,
              //   listOfColKey,
              //   data
              // )

              id="invoiceButton"
            >
              Print
            </Button>

            {table?.listOfData?.length > 0 ? (
              <ExportToExcel
                Data={dollarTrue ? table.listOfDataDollar : table.listOfData}
                listOfColKey={dollarTrue ? listOfColKeyDollar : listOfColKey}
                DynamicReports={true}
                ReportName="Daily_Sale/Receipt_Report"
                criteriaString={data.criteriaString}
              />
            ) : null}
          </div>
          <div translate="no" className="mt-5">
            {/* <div
              style={{
                textAlign: "right",
                marginBottom: "1%",
                marginTop: "5%",
              }}
            >
              <input
                type="text"
                style={{ borderRadius: "5px", height: "28px" }}
                placeholder="Search entire table"
                value={searchText}
                onChange={handleSearch}
              />
            </div> */}
            <div className="sticky-table-wrapper">
              <div className="sticky-table-container">
                <PaginationProvider pagination={paginationFactory(options)}>
                  {({ paginationProps, paginationTableProps }) => (
                    <div>
                      {/* TOP Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center my-2">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                        {/* <PaginationListStandalone {...paginationProps} /> */}
                      </div>

                      <BootstrapTable
                        // {...paginationTableProps}
                        key={`sale-summary-table-${showAsInteger}`}
                        keyField="id"
                        data={filteredData}
                        columns={dollarTrue ? Dollar_columns : columns}
                        defaultSorted={defaultSorted}
                        headerClasses="rpr_header"
                        tableBodyClass="rpr_body"
                        containerClass="rpr_container"
                        striped
                        condensed
                        hover
                        {...paginationTableProps}
                      />

                      {/* REMOVE this if you want pagination ONLY at the top */}
                      {/* <div className="d-flex justify-content-between align-items-center mt-2">
        <SizePerPageDropdownStandalone {...paginationProps} />
        <PaginationListStandalone {...paginationProps} />
      </div> */}
                    </div>
                  )}
                </PaginationProvider>
              </div>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
